import { FC } from "react";

type BadgeVariant = "gray" | "teal" | "red" | "gold";

interface TredingStockCardBadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
}

const TredingStockCardBadge: FC<TredingStockCardBadgeProps> = ({ children, variant = "gray" }) => {
  const styles: Record<BadgeVariant, string> = {
    gray: "bg-[#F2F2F2] text-[#666666]",
    teal: "bg-[#CEEAE5] text-[#067161]",
    red: "bg-[#B400001A] text-[#B40000]",
    gold: "bg-[#FEF0CA80] text-[#AD8507]",
  };

  return (
    <span
      className={`rounded-[2px] px-1 py-0.5 text-[8px] md:text-[10px] font-medium uppercase tracking-wide ${styles[variant]}`}
    >
      {children}
    </span>
  );
};

export default TredingStockCardBadge;